const customCategoryNames = {
  sv: {
    26: `Landfiske`,
    73: `Butik`,
    74: `Båtuthyrning`,
  },
}

const categoriesFeatured = {
  accommodation: {
    title: {
      en: `Accommodation`,
      sv: `Boende`,
      de: `Unterkunft`,
    },
    categories: [
      `55`, // accommodation
    ],
  },
  boatlaunch: {
    title: {
      en: `Boatlaunch`,
      sv: `Båtramp`,
      de: `Bootsrampe`,
    },
    categories: [
      `118`, // accommodation
    ],
  },
  fishing: {
    title: {
      en: `Fishing`,
      sv: `Landfiske`,
      de: `Angeln`,
    },
    categories: [
      `26`, // fishing
    ],
  },
  fishingwater: {
    title: {
      en: `Fishing Water`,
      sv: `Fiskevårdsområde`,
      de: `Gewässer`,
    },
    categories: [
      `229`, // fishing water
    ],
  },
  rental: {
    title: {
      en: `Rental`,
      sv: `Båtuthyrning`,
      de: `Verleih`,
    },
    categories: [
      `74`, // rental
    ],
  },
  shop: {
    title: {
      en: `Shop & Fishing guide`,
      sv: `Butik & Fiskeguide`,
      de: `Shop & Angelführer`,
    },
    categories: [
      `73`, // shop
      `76`, // guide
    ],
  },
}

module.exports = { customCategoryNames, categoriesFeatured }
